export const Javadata =
    `
                      /* Sample JavaScript edit source */
                      // Define a module
                      var app = angular.module('app', ['ui.bootstrap']);
                      // Define a conroller.
                      app.controller('GrokController', ['$scope', '$filter',
                      function($scope, $filter) {
                      $scope.today = function() {
                      $scope.dt = new Date();
                      };
                      $scope.today();
                      $scope.isOpened = false;
                      $scope.open = function($event) {
                      $event.preventDefault();
                      $event.stopPropagation();
                      $scope.isOpened = true;
                      };
                      }]);
                      /* End of sample edit source */
                    `;

export const HtmlData = ` <!--Page header start-->
<div className="page-header">
    <Row>
        <Col xl="6">
            <H3>Ace Text editor</H3>
            <small>Tivo Admin panel</small>
        </Col>
        <Col xl="6">
            <OL className="breadcrumb pull-right">
                <LI className="breadcrumb-item"></LI>
                <LI className="breadcrumb-item">Editor </LI>
                <LI className="breadcrumb-item active">Ace Text editor</LI>
            </OL>
        </Col>
    <Row>
</div>
<!--Page header end-->`;

export const CssData =
    `.text-layer
                      {
                      font: 12px Monaco, "Courier New", monospace;
                      font-size: 3vmin;
                      cursor: text;
                      }
                      .blinker {
                      animation: blink 1s linear infinite alternate;
                      }
                      @keyframes blink {
                      0%, 40% {
                      opacity: 1
                      }
                      40.5%, 100% {
                      opacity: 1
                      }
                      }
                      @document url(http://c9.io/), url-prefix(http://ace.c9.io/build/),
                      domain(c9.io), regexp("https:.*") /**/
                      {
                      /**/
                      img[title]:before
                      {
                      content: attr(title) "A Image retrieved from" attr(src); /**/
                      white-space: pre;
                      display: block;
                      background: url(asdasd); "err
                      }
                      }
                      @viewport {
                      min-zoom: 1;
                      max-zoom: 200%;
                      user-zoom: fixed;
                      }`;

export const Typescript =
    `class Animal{
        String color="white";
        }
        class Dog extends Animal{
        String color="black";
        void printColor(){
        System.out.println(color);//prints color of Dog class
        System.out.println(super.color);//prints color of Animal class
        }
        }
        class TestSuper1{
        public static void main(String args[]){
        Dog d=new Dog();
        d.printColor();
        }}  `;